export var MAXPAYOUT_DATA = "MAXPAYOUT_DATA";
export var MAXPAYOUT_HIDE_ERROR = "MAXPAYOUT_HIDE_ERROR";
export var MAXPAYOUT_ERROR = "MAXPAYOUT_ERROR";
